import { curry } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { hidden, hide } from 'lib/sequence/component/state/hidden'

/**
 * Toggles the display of the list filter section.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const toggleFilter = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
)=> {
  const action = module[G.STATE][G.ACTION]
  const actionComponent = action[G.COMPONENT]
  const { filter } = find(actionComponent)

  const { quickActions = [] } = action[G.UI]
  const filterAction = quickActions.find((quickAction: any) => quickAction.key === 'filter')

  const isHidden = hidden(filter)

  filterAction.active = isHidden
  hide(filter, !isHidden)

  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(toggleFilter)
